import React from 'react';
import ISVGIcon from './interfaces/ISVGIcon';

const MinusChunky = ({ fill }: ISVGIcon): React.ReactElement => (
    <svg viewBox="0 0 24 24">
        <style type="text/css" />
        <g>
            <rect x="6.5" y="11.5" className="st0" width="11" height="1" />
            <polygon fill={fill} points="18,11 6,11 6,13 18,13 18,11 " />
        </g>
    </svg>
);

export default MinusChunky;
